export const categories = [
  {
    name: "Shoes",
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    color: "bg-[#faf5f0]",
    image: "https://readdy.ai/api/search-image?query=Pair%20of%20chunky%20retro%20sneakers%20in%20soft%20pastel%20lavender%20and%20mint%20colorway%20on%20a%20clean%20warm%20terracotta%20terrazzo%20surface%2C%20bright%20morning%20sunlight%20casting%20crisp%20shadows%2C%20editorial%20product%20photography%2C%20fresh%20spring%20vibe%2C%20no%20text%2C%20vibrant%20yet%20soft%20color%20palette&width=800&height=1000&seq=cat-shoes-v2-a&orientation=portrait",
  },
  {
    name: "Hoodies/Sweaters",
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    color: "bg-[#f2ede5]",
    image: "https://readdy.ai/api/search-image?query=Vintage%20washed%20cotton%20hoodie%20in%20dusty%20coral%20pink%20draped%20over%20a%20wooden%20stool%20against%20a%20soft%20butter%20yellow%20wall%2C%20afternoon%20light%20from%20side%20window%2C%20editorial%20style%2C%20textured%20fabric%20details%2C%20no%20text%2C%20warm%20nostalgic%20aesthetic&width=800&height=1000&seq=cat-hoodies-v2-b&orientation=portrait",
  },
  {
    name: "T-Shirts",
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    color: "bg-[#f7f2ec]",
    image: "https://readdy.ai/api/search-image?query=Boxy%20oversized%20organic%20cotton%20tee%20in%20soft%20pistachio%20green%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20warm%20clay%20colored%20plaster%20wall%2C%20natural%20diffused%20light%2C%20Scandinavian%20aesthetic%2C%20clean%20composition%2C%20no%20text%2C%20earthy%20calm%20tones&width=800&height=1000&seq=cat-tshirts-v2-c&orientation=portrait",
  },
  {
    name: "Jackets",
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    color: "bg-[#ede8df]",
    image: "https://readdy.ai/api/search-image?query=Lightweight%20denim%20trucker%20jacket%20in%20soft%20sky%20blue%20wash%20laid%20flat%20on%20a%20textured%20oatmeal%20linen%20surface%2C%20overhead%20softbox%20lighting%2C%20editorial%20product%20photography%2C%20visible%20weave%20details%2C%20no%20text%2C%20relaxed%20weekend%20vibe&width=800&height=1000&seq=cat-jackets-v2-d&orientation=portrait",
  },
  {
    name: "Pants/Shorts",
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    color: "bg-[#f0ede4]",
    image: "https://readdy.ai/api/search-image?query=Relaxed%20fit%20linen%20blend%20trousers%20in%20warm%20sand%20color%20elegantly%20draped%20over%20a%20rattan%20chair%20on%20a%20sunlit%20terrace%2C%20Mediterranean%20light%2C%20editorial%20style%2C%20breezy%20fabric%20movement%2C%20no%20text%2C%20vacation%20aesthetic&width=800&height=1000&seq=cat-pants-v2-e&orientation=portrait",
  },
  {
    name: "Headwear",
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    color: "bg-[#f5efe6]",
    image: "https://readdy.ai/api/search-image?query=Classic%20six-panel%20twill%20cap%20in%20soft%20sage%20green%20placed%20on%20a%20smooth%20river%20stone%20against%20a%20warm%20sand%20background%2C%20golden%20hour%20side%20lighting%2C%20editorial%20product%20photography%2C%20subtle%20embroidery%20detail%2C%20no%20text%2C%20outdoor%20aesthetic&width=800&height=1000&seq=cat-headwear-v2-f&orientation=portrait",
  },
  {
    name: "Sets",
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    color: "bg-[#efe9df]",
    image: "https://readdy.ai/api/search-image?query=Matching%20coord%20set%20in%20warm%20cinnamon%20brown%20ribbed%20knit%20fabric%20displayed%20on%20a%20minimalist%20oak%20shelf%20against%20a%20creamy%20white%20wall%2C%20soft%20studio%20lighting%2C%20editorial%20style%2C%20textural%20contrast%2C%20no%20text%2C%20modern%20lounge%20aesthetic&width=800&height=1000&seq=cat-sets-v2-g&orientation=portrait",
  },
  {
    name: "Underwear/Underpants",
    slug: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    color: "bg-[#f8f3ec]",
    image: "https://readdy.ai/api/search-image?query=Premium%20modal%20cotton%20boxer%20briefs%20in%20soft%20heather%20grey%20neatly%20rolled%20on%20a%20smooth%20marble%20surface%20with%20a%20small%20eucalyptus%20sprig%2C%20clean%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20no%20text%2C%20spa-like%20calm%20aesthetic&width=800&height=1000&seq=cat-underwear-v2-h&orientation=portrait",
  },
  {
    name: "Jersey",
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    color: "bg-[#ece8df]",
    image: "https://readdy.ai/api/search-image?query=Vintage-style%20soccer%20jersey%20in%20faded%20mustard%20yellow%20with%20subtle%20stripes%20hung%20on%20a%20minimalist%20wall%20hook%20against%20a%20warm%20grey%20concrete%20wall%2C%20industrial%20loft%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20retro%20sport%20aesthetic&width=800&height=1000&seq=cat-jersey-v2-i&orientation=portrait",
  },
  {
    name: "Accessories",
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    color: "bg-[#f4efe6]",
    image: "https://readdy.ai/api/search-image?query=Set%20of%20minimalist%20gold%20tone%20jewelry%20including%20layered%20necklace%20and%20hoop%20earrings%20scattered%20artfully%20on%20a%20raw%20silk%20fabric%20in%20soft%20blush%20pink%2C%20macro%20photography%2C%20soft%20glamour%20lighting%2C%20no%20text%2C%20elegant%20jewelry%20editorial&width=800&height=1000&seq=cat-accessories-v2-j&orientation=portrait",
  },
  {
    name: "Bags",
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    color: "bg-[#ede6da]",
    image: "https://readdy.ai/api/search-image?query=Structured%20canvas%20tote%20bag%20in%20natural%20undyed%20cotton%20with%20brown%20leather%20handles%20standing%20on%20a%20weathered%20wooden%20bench%2C%20morning%20sunlight%20through%20leaves%2C%20editorial%20style%2C%20organic%20texture%20contrast%2C%20no%20text%2C%20artisan%20market%20aesthetic&width=800&height=1000&seq=cat-bags-v2-k&orientation=portrait",
  },
  {
    name: "Belts",
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    color: "bg-[#f2efe7]",
    image: "https://readdy.ai/api/search-image?query=Handcrafted%20braided%20leather%20belt%20in%20rich%20cognac%20brown%20coiled%20gracefully%20on%20a%20smooth%20slate%20stone%20surface%2C%20dramatic%20side%20lighting%20creating%20deep%20shadows%2C%20editorial%20product%20photography%2C%20no%20text%2C%20luxury%20craftsmanship%20aesthetic&width=800&height=1000&seq=cat-belts-v2-l&orientation=portrait",
  },
  {
    name: "Perfumes",
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    color: "bg-[#f6f0e8]",
    image: "https://readdy.ai/api/search-image?query=Artisan%20amber%20glass%20perfume%20bottle%20with%20wooden%20cap%20surrounded%20by%20dried%20lavender%20and%20citrus%20peels%20on%20a%20warm%20honey%20colored%20linen%2C%20soft%20window%20light%2C%20editorial%20still%20life%2C%20no%20text%2C%20apothecary%20vintage%20aesthetic&width=800&height=1000&seq=cat-perfumes-v2-m&orientation=portrait",
  },
  {
    name: "Other Stuff",
    slug: "other-stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    color: "bg-[#eae7de]",
    image: "https://readdy.ai/api/search-image?query=Eclectic%20arrangement%20of%20lifestyle%20items%20including%20ceramic%20mug%20candle%20and%20small%20decorative%20objects%20on%20a%20warm%20maple%20wood%20surface%2C%20afternoon%20sunlight%20creating%20lens%20flare%2C%20editorial%20flat%20lay%2C%20no%20text%2C%20cozy%20home%20aesthetic&width=800&height=1000&seq=cat-other-v2-n&orientation=portrait",
  },
];